import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[softFocus]',
  exportAs: 'softFocus',
})
export class SetFocusDirective implements AfterViewInit {
  constructor(private el: ElementRef) {
    if (!el.nativeElement['focus']) {
      console.warn(
        '[SetFocusDirective] Attempting to set focus on an element that does not support focus'
      );
    }
  }

  ngAfterViewInit(): void {
    this.focus();
  }

  focus(): void {
    let input: HTMLInputElement | undefined;
    const stack = [this.el.nativeElement];
    while (stack.length) {
      const current = stack.pop();
      if (current.tagName === 'INPUT' || current.tagName === 'TEXTAREA') {
        input = current as HTMLInputElement;
        break;
      } else if (current.children?.length) stack.push(...current.children);
    }

    if (input) input.focus();
  }
}
